<template>
  <el-container style="min-height:100vh">
    <el-aside width="200px" style="background:#304156">
      <div class="logo">sharepay 管理</div>
      <el-menu :default-active="activeMenu" router background-color="#304156" text-color="#bfcbd9"
        active-text-color="#409EFF" style="border-right:none">
        <el-menu-item index="/dashboard"><i class="el-icon-s-data" /><span>数据面板</span></el-menu-item>
        <el-menu-item index="/bloggers"><i class="el-icon-s-cooperation" /><span>博主管理</span></el-menu-item>
        <el-menu-item index="/users"><i class="el-icon-user" /><span>用户管理</span></el-menu-item>
        <el-menu-item index="/resources"><i class="el-icon-folder" /><span>资源管理</span></el-menu-item>
        <el-menu-item index="/withdraw"><i class="el-icon-money" /><span>提现处理</span></el-menu-item>
        <el-menu-item index="/withdraw/history"><i class="el-icon-time" /><span>提现历史</span></el-menu-item>
        <el-menu-item index="/settings"><i class="el-icon-setting" /><span>系统配置</span></el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header style="background:#fff; display:flex; align-items:center; justify-content:space-between;
        border-bottom:1px solid #e6e6e6">
        <span class="text-gray-500">欢迎，{{ user ? user.username : '' }}</span>
        <el-button type="text" @click="onLogout">退出</el-button>
      </el-header>
      <el-main style="background:#f0f2f5">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['user']),
    activeMenu() { return this.$route.path; }
  },
  methods: {
    onLogout() {
      this.$store.dispatch('logout');
      this.$router.replace('/login');
    }
  }
};
</script>

<style scoped>
.logo {
  height: 60px; line-height: 60px; text-align: center;
  color: #fff; font-size: 18px; font-weight: bold;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}
</style>
